/**
 * 颜色工具函数
 */

/**
 * 根据字符串生成一个唯一的颜色值
 * @param {string} str - 输入字符串
 * @returns {string} - 返回HSL颜色值
 */
export const getColorByString = (str) => {
    if (!str || typeof str !== "string") return "hsl(0, 0%, 85%)";

    // 简单的字符串哈希算法  12 为基数，可以减少碰撞
    const hash = Array.from(str).reduce((acc, char) => char.charCodeAt(0) + ((acc << 12) - acc), 0);

    // 生成柔和的颜色，适合Tag使用
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 85%, 70%)`;
};

/**
 * 预定义颜色集合，用于循环使用
 */
export const PRESET_COLORS = [
    "#E6F7FF", // 浅蓝
    "#F6FFED", // 浅绿
    "#FFF7E6", // 浅橙
    "#FCF5FF", // 浅紫
    "#FFF1F0", // 浅红
    "#FFFBE6", // 浅黄
    "#F0F5FF", // 靛青
    "#F5F5F5", // 灰色
];

/**
 * 根据索引获取预设颜色
 * @param {number} index - 颜色索引
 * @returns {string} - 返回预设颜色
 */
export const getPresetColor = (index) => {
    if (typeof index !== "number") return PRESET_COLORS[0];
    return PRESET_COLORS[index % PRESET_COLORS.length];
};
